import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  model,
  output,
} from '@angular/core';
import { AutomationContext } from '@kinet-open-network/shared/data-access/model';
import { ButtonModule } from 'primeng/button';
import {
  FieldChangeTriggerService,
  IFieldChangeRule,
} from './field-change-trigger.service';
import { FieldChangeRuleComponent } from './rules/abstract-field-change-rule.component';

@Component({
  selector: 'kon-field-change-trigger-rule-container',
  imports: [ButtonModule, FieldChangeRuleComponent],
  template: `
    <div class="flex items-start gap-2">
      <div class="grow">
        <kon-field-change-rule
          [context]="context()"
          [rule]="rule()"
          (ruleChange)="rule.set($event)"
        />
      </div>

      <p-button
        type="button"
        icon="pi pi-times"
        pTooltip="Zmazať podmienku"
        [text]="true"
        [severity]="'danger'"
        [size]="'small'"
        [rounded]="true"
        (click)="removeRule()"
      ></p-button>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldChangeTriggerRuleContainerComponent {
  readonly #triggerService = inject(FieldChangeTriggerService);

  readonly context = input<AutomationContext | undefined>();
  readonly rule = model<Partial<IFieldChangeRule>>(
    this.#triggerService.createRule(),
  );
  readonly ruleRemove = output<void>();

  removeRule() {
    this.ruleRemove.emit();
  }
}
